import { FC, useContext } from 'react';

import { BottomSheet } from 'components/design-system/BottomSheet';
import { Button } from 'components/design-system/Button';
import { useModal } from 'context/modal/ModalContext';
import { SellerProfileContext } from 'context/sellerProfile';
import styles from 'styles/FinalOffer.module.scss';
import { Offer } from 'types';
import { formatPrice } from 'utils/text-helpers';

import { FinalOfferPriceSlideout } from './FinalOfferPriceSlideout';

export type FinalOfferPropositionBottomSheetProps = {
  offer: Offer;
  openFinalOfferInfoBottomSheet: () => void;
};

export const FinalOfferPropositionBottomSheet: FC<FinalOfferPropositionBottomSheetProps> = ({
  offer,
  openFinalOfferInfoBottomSheet
}) => {
  const { openModal, closeModal } = useModal();
  const { sellerProfile, sellerLevels } = useContext(SellerProfileContext);
  const initialPrice = offer.listing.priceCents;
  const finalPrice = offer.dealTrigger?.dealPriceCents || 0;

  const discountValue = formatPrice(initialPrice - finalPrice);

  const onOpenSetFinalOfferPriceSlideout = () => {
    openModal(
      <FinalOfferPriceSlideout
        offer={offer}
        sellerProfile={sellerProfile}
        sellerLevels={sellerLevels}
        closeModal={closeModal}
      />,
      true
    );
  };

  return (
    <BottomSheet className='pb-5'>
      <div className='d-flex flex-column align-items-center text-center'>
        <h4 className='fs-20px line-height-32px letter-spacing-007'>
          Do you want to boost your last counter as a Final Offer?
        </h4>
        <div className='w-80 border-radius-24 py-3 bg-lightGreen my-3'>
          <div className='fs-12px letter-spacing-08 text-success'>24-HOUR FINAL OFFER BOOST</div>
          <div className='fs-32px opacity-90 riforma-regular text-success py-2'>{formatPrice(finalPrice)}</div>
          <div className='riforma-regular opacity-60'>{discountValue} off</div>
        </div>
        <div className='my-4 fs-16px riforma-regular letter-spacing-006'>
          <div className='opacity-60'>
            We’ll take the price you last countered at and show it to likely buyers for 24 hours.
          </div>
          <div onClick={openFinalOfferInfoBottomSheet} role='button' className={styles.learnMore}>
            Learn more
          </div>
        </div>
        <Button onClick={onOpenSetFinalOfferPriceSlideout} className='w-100 mb-4 py-3'>
          Get started
        </Button>
      </div>
    </BottomSheet>
  );
};
